import { checkPaymentStatusInterval } from './status';
import { handleSubmitForm, handleInputChange, handleEntityIdTypeChange, handleEntityTypeChange } from './handlers';
import { checkPeriodType, prepareAccount, setEntityIdType } from './actions';

const form = document.querySelector('.payment-tax-form');

const addEventDataType = () => {
  if (!form) return false;

  const btns = form.querySelectorAll('button[data-type]');
  if (btns.length > 0) {
    btns.forEach(item => item.addEventListener('click', handleEntityTypeChange));
  }
}

const addEventIdTypeChange = () => {
  if (!form) return false;

  const field = form.querySelector('.id-type select');
  field.addEventListener('change', handleEntityIdTypeChange);
}

const addEventIdChange = () => {
  if (!form) return false;

  const field = form.querySelector('.id-data input');
  field.addEventListener('keyup', () => prepareAccount());
}

const addEventAllFields = () => {
  const allFields = form.querySelectorAll('input, select');
  allFields.forEach(item => item.addEventListener('input', handleInputChange))
}

const addEventOnSubmit = () => form.addEventListener('submit', handleSubmitForm);


const init = () => {
  if (!form) return false;
  addEventDataType();
  addEventIdChange();
  // addEventAmountChange();
  setEntityIdType(false);
  prepareAccount(false);
  addEventOnSubmit();
  addEventAllFields();
  checkPeriodType();
  addEventIdTypeChange();
  checkPaymentStatusInterval();
}

export default init();